export default __webpack_public_path__ + "images/7b8d82b024a5aaa76192c1a940063eb6.png";